/**
 * EX 21-09-2026 (Fase 3): un solo lugar para el payload de guardado del expediente.
 *
 * Antes habia TRES copias del mismo objeto (saveExit y saveSeguir del alta, y
 * saveSeguir_prueba de la edicion). Eran casi identicas y ya se habian desincronizado:
 * saveSeguir manda 'fecha_actualizacion' y saveExit no; el alta manda 'id_exp_prueba' y la
 * edicion no (lleva el id en estadoExp); y saveSeguir declara
 * 't_144_proyecto_hidraulico' dos veces. Ese es el motivo de la fase: la lista vive aca.
 *
 * El nucleo son las 84 claves que los tres bodies tienen en comun (medido con el AST, no a
 * mano). Las diferencias NO se unifican en este paso (opcion (b), 21-09-2026): cada llamador
 * sigue mandando lo suyo por 'extras', asi el payload sale IDENTICO a antes y se puede
 * comparar con el A/B. Unificar la regla de la fecha es un paso aparte, ya con un solo lugar.
 *
 * Un valor undefined deja la clave fuera del JSON, igual que antes: es lo que pasa con
 * id_exp_prueba en la edicion, que lleva el id en estadoExp.
 */

const CLAVES_EXPEDIENTE = [
	"acta_constitutiva_t", "admisibilidad_inicial_t", "agua_potable_t", "anotaciones_personales_t",
	"anteproyecto_urbano_t", "apertura_calles_t", "area", "avanzados",
	"boletos", "cantidad_lotes", "cantidad_lotes_adjudicables", "censosEnviar",
	"certif_no_inundabilidad_t", "certif_tecnico_urbanistico_t", "certif_urbanistico_municipal_t", "certif_vigencia_persona_juridica_t",
	"convenio_urbanistico_t", "datos_05_responsable", "datos_18_sintesis_nomenclatura", "datos_19_partido_nomencla",
	"datos_20_circ_nomencla", "datos_21_secc_nomencla", "datos_22_geom", "decreto_promulgatorio",
	"eliminacion_excretas", "eliminacion_excretas_t", "energia_electrica_t", "estado",
	"estadoExp", "expediente", "expediente_prefac_h_t", "fecha_caratulacion",
	"fecha_carga", "fecha_emision_prefac_h_t", "fecha_emision_resol_t", "fecha_envio_prefac_h_t",
	"fecha_envio_resol_t", "fecha_visado_plano_t", "formRows", "informe_dominio_t",
	"inputsCSP", "localidad", "lotes_adquiridos_municipio", "memoria_descriptiva_obras_t",
	"memoria_descriptiva_procedimientos_t", "name", "nombre_proyecto", "nro_ordenanza_vigente",
	"numero_especial_resol_t", "observaciones_censo", "observaciones_generales", "observaciones_internas_t",
	"observaciones_reporte_t", "ordenanza_municipal_t", "partido", "plano_mensura_t",
	"plano_oficial", "porc_lotes_municipales", "prefactibilidad_hidraulica_t", "prefactibilidad_urbanistica_t",
	"programa", "resolucion_afectacion_t", "sistema_agua", "solicitud_adhesion_t",
	"t_127_tramitacion_ada_prefac_h", "t_131_observaciones_prefact_h", "t_132_tramitacion_resol", "t_136_observaciones_resol",
	"t_137_tramitacion_visado", "t_139_fecha_entrega", "t_140_observaciones_tramitacion", "t_144_proyecto_hidraulico",
	"t_145_cpu_tramitacion", "t_146_cpu_fecha_envio", "t_147_cpu_fecha_emision", "t_148_cpu_nro_gdeba",
	"t_149_cpu_observaciones", "tipo", "titular_tierra", "titulo_propiedad_t",
	"tramite_prioritario", "tramites", "visado_plano_t", "zonificacion",
];

const construirPayload = (campos, extras = {}) => {
	const body = {};
	CLAVES_EXPEDIENTE.forEach((clave) => { body[clave] = campos[clave]; });
	Object.assign(body, extras);
	return body;
};

export { CLAVES_EXPEDIENTE, construirPayload };
export default construirPayload;
